import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/_api';
import { CHANNEL, PATH_UTILS } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types } from './types';

// ACTIONS
import { consultaCidadesUFSuccess, consultaCidadesUFFailure } from './actions';

function* consultaCidadesUF(request: ReducerAction) {
	const { payload }: { payload: string } = request;
	const response: ApiResponse = yield call(
		getApi,
		PATH_UTILS,
		`cidades/${CHANNEL}/uf/${payload}`,
		{},
	);

	if (response.status === 200 || response.status === 202) {
		yield put(consultaCidadesUFSuccess(response));
	} else if (response.error) {
		yield put(consultaCidadesUFFailure(response.error));
	}
}

export default all([
	takeLatest(Types.CONSULTA_CIDADES_UF_REQUEST, consultaCidadesUF),
]);
